export default __webpack_public_path__ + "static/media/logo.4cb52ae9.png";